import React, { useState } from "react";
import {
    Table, TableBody, TableCell, TableHead, TableRow, Card, Box, Button,
    TextField, MenuItem, Select, FormControl, InputLabel, Grid, Paper
} from "@material-ui/core";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import SubActivityService from "./Locality/Service/subActivityService";
import StudentCards from "./UserProfileCard";

import { useEffect } from 'react';
import ActivityService from "./Locality/Service/activityService";
import SuperActivityService from "./Locality/Service/superActivityService"
import StudentService from "./Locality/Service/studentService"
const statuses = ["P", "WA", "WI", "M"]; // Presented, Work with Assistance, etc.
const statusLabels = {
    P: "Presented",
    WA: "Works with Assistance",
    WI: "Works Independently",
    M: "Mastered",
};

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));

export default function ParentActivityTrackerTable() {
    const classes = useStyles();

    const [activityList, setActivityList] = useState([]);
    const [studentsList, setstudentsList] = useState([]);
    var [classId, setClassId] = useState(null);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    var [isLoading, setIsLoading] = useState(false);
    const [addClassList, setAddClassList] = useState([]);
    var [studentId, setStudentId] = useState("");

    const [activeTab, setActiveTab] = useState('');
    useEffect(() => {
        // getAddClassList();
        getSuperActivityList();
        fetchStudentList();

        return () => {
            setStudentList([]);
            setAddSuperActivityList([]);
            setActivityList([]);
        }
    }, []);
    const colorMap = {
        "P": "#5C9882",
        "WI": "#E6B163",
        "WA": "#A75C9C",
        "M": '#147ad482'
    };
    const onSubmit = (data, studentsId, classsId) => {
        setIsLoading(true); // Start loading

        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        const keys = {
            schooleId: userDetails.schooleId,
            isFuturePlanning: false,
            isInitLoad: true,
            superActivityId: data,
            studentId: studentsId ? studentsId : studentId,
            classId: classsId ? classsId : classId,
            startDate: "",
            endDate: "",
            status: true,
            publicStatus:userDetails.filterStatus ? null :'publish'
        };

        ActivityService.findActivityReports(keys)
            .then((result) => {
                setActivityList(result);

                const allStudents = [];
                const allActivities = [];
                result.forEach(activity =>
                    activity.activityList.forEach(rec => {
                        const student = rec.studentId;
                        if (student && !allStudents.find(s => s._id === student._id)) {
                            allStudents.push(student);
                        }
                    })
                );
                setstudentsList(allStudents);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setIsLoading(false); // End loading
            });
    };


    const getSuperActivityList = async (studentId, classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        try {
            const res = await SuperActivityService.getAllSuperActivityById(userDetails.schooleId, { classId: classId });
            setAddSuperActivityList(res);

            if (res.length > 0) {
                setActiveTab(res[0]._id);
                onSubmit(res[0]._id, studentId, classId);
            }
        } catch (err) {
            console.error(err);
        }
    };
    const fetchStudentList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        StudentService.findStudentList({ userId: userDetails._id })
            .then((res) => {
                const mappedStudents = res.map((student) => ({
                    ...student,
                    fullName: `${student.firstName} ${student.lastName}`,
                }));
                setStudentList(mappedStudents);

                if (mappedStudents.length > 0) {
                    setStudentId(mappedStudents[0]._id);
                    setClassId(mappedStudents[0].classId._id);
                    //  onSubmit(mappedStudents[0]._id, mappedStudents[0].classId._id);
                    getSuperActivityList(mappedStudents[0]._id, mappedStudents[0].classId._id);
                }

            })
            .catch((err) => console.error(err));
    };
    const handleTabClick = (superActivityId) => {

        setActiveTab(superActivityId);
        onSubmit(superActivityId, studentId, classId);
    };
    const handleStudentClick = (studentId, classId) => {
        getSuperActivityList(studentId, classId);
        // You can now fetch the student's assignments or do anything with this ID
    };
    const getStudentReportList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        if (studentId == '') {
            alert("Please Select Student");
            return;
        }
        const getstudentId = { "studentId": studentId, };

        SubActivityService.getStudentReport(getstudentId).then((res) => {
            // const blob = new Blob(res.pdfBuffer);
            const buffer = Buffer.from(res.pdfBuffer);
            const blob = new Blob([buffer]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "studentreport.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            // const blob = new Blob([res.pdfBuffer]);
            // saveAs(blob, 'filename.pdf');
            // const file = new File(res.pdfBuffer, 'filename.txt', { type: 'text/plain' });
            // setStudentReportList(res);
        }).catch((err) => {
            alert(err.response.data.message)
        });
    }
    return (
        <Paper style={{ padding: 20 }}>

            <Card sx={{ maxWidth: 345 }}>
                {studentList.length > 1 && (<Box style={{ margin: 15 }}>
                    <StudentCards studentList={studentList} onStudentSelect={handleStudentClick} />

                </Box>)}
            </Card>
            <div className="overflow-x-auto activity-record p-4 space-y-6">
                <div>
                    <h2 className="text-xl font-bold mb-2 text-gray-700">Area Of Work</h2>

                </div>
                <br></br>
                <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                    <div style={{ display: 'inline-flex', gap: '10px', paddingBottom: '10px' }}>
                        {addSuperActivityList.map((area) => {
                            const isActive = activeTab === area._id;
                            return (
                                <button
                                    key={area._id}
                                    onClick={() => handleTabClick(area._id)}
                                    style={{
                                        padding: '10px 16px',
                                        borderBottom: isActive ? '3px solid rgb(15 59 98)' : '3px solid transparent',
                                        backgroundColor: isActive ? '#DBEAFE' : 'transparent',
                                        color: isActive ? 'rgb(15 59 98)' : '#4B5563',
                                        fontWeight: '600',
                                        borderRadius: '6px 6px 0 0',
                                        whiteSpace: 'nowrap',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {area.superActivityName}
                                </button>
                            );
                        })}

                    </div>
                </div>
                <br></br>
                {studentId && !isLoading && (
                    <div style={{ overflowX: "auto" }}>
                        <table
                            border="1"
                            cellPadding="8"
                            style={{
                                borderCollapse: "collapse",
                                minWidth: "800px",
                                width: "max-content",
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={{ width: "500px" }}>Activity</th>
                                    <th>Presented (P)</th>
                                    <th>Works with Assistance (WA)</th>
                                    <th>Works Independently (WI)</th>
                                    <th>Mastered (M)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activityList.map((activity) => {
                                    const record = activity.activityList[0]; // assuming single student

                                    const getStatusCell = (statusCode, activityRecordsId) => {
                                        let activityDetails = null;
                                        if (activityRecordsId && activityRecordsId.length > 0) {
                                            activityDetails = activityRecordsId[0].statusHistory?.find(
                                                (item) => item.key === statusCode
                                            );
                                        }

                                        const bgColor = colorMap[statusCode];

                                        return (
                                            <td
                                                style={{
                                                    backgroundColor: activityDetails ? bgColor : "transparent",
                                                    textAlign: "center",
                                                    fontWeight: "bold",
                                                    color: activityDetails ? "white" : "black",
                                                }}
                                            >
                                                {activityDetails && activityDetails.changedAt
                                                    ? new Date(activityDetails.changedAt).toLocaleDateString("en-GB")
                                                    : "-"}
                                            </td>
                                        );
                                    };

                                    return (
                                        <tr key={activity.id}>
                                            <td
                                                style={{
                                                    backgroundColor: "#F3F4F6",
                                                    fontWeight: "bold",
                                                    color: "#111827",
                                                    textAlign: "left",
                                                    padding: "8px",
                                                    verticalAlign: "top",
                                                }}
                                            >
                                                {activity.activityName}
                                            </td>
                                            {getStatusCell("P", record?.activityRecordsId)}
                                            {getStatusCell("WA", record?.activityRecordsId)}
                                            {getStatusCell("WI", record?.activityRecordsId)}
                                            {getStatusCell("M", record?.activityRecordsId)}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {isLoading && (
                    <div className="text-center p-4 text-blue-600">Loading data...</div>
                )}

            </div>

        </Paper>
    );
}
